/**
 * Transaction status values
 */
export enum TransactionStatusEnum {
	/**
	 * Transaction is pending
	 */
	PENDING = 'pending',

	/**
	 * Transaction is being processed
	 */
	PROCESSING = 'processing',

	/**
	 * Transaction has been completed
	 */
	COMPLETED = 'completed',

	/**
	 * Transaction has been cancelled
	 */
	CANCELLED = 'cancelled',

	/**
	 * Transaction is being retried
	 */
	RETRYING = 'retrying',

	/**
	 * Transaction has failed
	 */
	FAILED = 'failed',

	/**
	 * Transaction has expired
	 */
	EXPIRED = 'expired',

	/**
	 * Transaction has been refunded
	 */
	REFUNDED = 'refunded',
}
